import { useQuery } from '@tanstack/react-query';
import { ServiceRequestType } from 'src/models';
import { api } from 'src/services';
import { useSuperAdminApiOverrides } from '../superAdmin';

type GetServiceRequestTypesResponse = {
  data: Array<ServiceRequestType>;
};

export const useGetServiceRequestTypes = () => {
  const { headers } = useSuperAdminApiOverrides();

  return useQuery({
    queryKey: ['serviceRequestTypes'],
    queryFn: () =>
      api
        .get<GetServiceRequestTypesResponse>('v3/service_request/types', {
          headers,
        })
        .then(({ data }) => data.data),
  });
};
